<template>
    <v-form>
        <v-row class="mx-0 pt-8">
            <v-col cols="12">
                <h2>Цена закупки</h2>
            </v-col>
            <v-col cols="12" class="mx-0" v-if="amountPolicies.length">
                <CommercialPolicyAmount :policy-data="amountPolicies" :currencies="currencies" @change="amountChange" @delete-policy="deleteAmount"/>
            </v-col>
            <v-col cols="12" class="mx-0" v-if="!amountPolicies.length">
                Политики отсутствуют
            </v-col>
        </v-row>
        <div class="spacer"></div>
        <v-row class="mx-0 pt-8">
            <v-col cols="12">
                <h2>Период поставки</h2>
            </v-col>
            <v-col cols="12" class="mx-0" v-if="datePolicies.length">
                <CommercialPolicyDate :policy-data="datePolicies" :currencies="currencies" @change="dateChange" @delete-policy="deleteDates"/>
            </v-col>
            <v-col cols="12" class="mx-0" v-if="!datePolicies.length">
                Политики отсутствуют
            </v-col>
        </v-row>
        <v-row class="mx-0 pt-8">
            <v-col cols="12">
                <h2>Способ оплаты</h2>
            </v-col>
            <v-col cols="12" class="mx-0">
                <CommercialPolicyPayment :policy-data="paymentPolicies" :currencies="currencies" @change="paymentChange" @delete-policy="deletePayments"/>
            </v-col>
        </v-row>
        <div class="spacer"></div>
        <v-row class="mx-0">
            <v-col cols="12" class="text-center text-sm-right">
                <v-btn icon color="teal" @click="$emit('save')">Сохранить</v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    import UserDataMixin from "./UserDataMixin"
    import CommercialPolicyAmount from "./CommercialPolicyAmount"
    import CommercialPolicyDate from "./CommercialPolicyDate"
    import CommercialPolicyPayment from "./CommercialPolicyPayment"

    import { InfoService } from "../../../../services"

    export default {
        name: "CommercialPolicyInfo",
        mixins: [UserDataMixin],
        components: {CommercialPolicyAmount, CommercialPolicyDate, CommercialPolicyPayment},
        data() {
            return {
                dataKey: 'commercialPolicyInfo',
                currencies: []
            }
        },
        computed: {
            amountPolicies() {
                return this.baseUserData.amountPolicy || [];
            },
            datePolicies() {
                return this.baseUserData.datePolicy || [];
            },
            paymentPolicies() {
                return this.baseUserData.paymentPolicy || [];
            }
        },
        methods: {
            amountChange(data) {
                this.baseUserData.amountPolicy = data;
                this.emitUpdate();
            },
            dateChange(data) {
                this.baseUserData.datePolicy = data;
                this.emitUpdate();
            },
            paymentChange(data) {
                this.baseUserData.paymentPolicy = data;
                this.emitUpdate();
            },
            deleteAmount(id) {
                this.baseUserData.amountPolicy = this.amountPolicies.filter(item => item.id !== id);
                this.emitUpdate();
            },
            deleteDates(id) {
                this.baseUserData.datePolicy = this.datePolicies.filter(item => item.id !== id);
                this.emitUpdate();
            },
            deletePayments(data) {
                this.baseUserData.paymentPolicy = data;
                this.emitUpdate();
            },
            setCurrencies() {
                InfoService.getCurrencies().then((res) => {
                    this.currencies = res.data;
                }).catch((err) => {});
            },
            getEmitData() {
                return {
                    key: this.dataKey,
                    data: this.baseUserData
                }
            },
            emitUpdate() {
                this.$emit('update', this.getEmitData());
            }
        },
        created() {
            this.setCurrencies();
        }
    }
</script>

<style scoped>

</style>